module.exports = __webpack_public_path__ + "img/day--gray.7ef6f1bd.svg";